import React, { useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Loader } from "../../components/Loader/Loader";
import { AppDispatch, RootState } from "../../store";
import { getPosts } from "../../store/slices/postsSlice";
import { Post } from "../Blog/Post/Post";
import { PostsList } from "../Blog/styles";

type RecommendedProps = {
    currentPostId: number;
};

export const Recommended: React.FC<RecommendedProps> = ({ currentPostId }) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const { posts, loading, error } = useSelector((state: RootState) => state.posts);

  useEffect(() => {
    if (posts.length === 0) {
      dispatch(getPosts());
    }
  }, [dispatch, posts.length]);

  const handlePostClick = (id: number) => {
    navigate(`/blog/${id}`);
  };

  const recommendedPosts = useMemo(() => {
    const filtered = posts.filter(post => post.id !== currentPostId);

    return filtered
      .sort(() => 0.5 - Math.random()) // перемешивание
      .slice(0, 3); // выбор 3-х
  }, [posts, currentPostId]);

  if (loading) return <Loader />;
  if (error) return <div>Ошибка: {error}</div>;
  if (recommendedPosts.length === 0) return <div>Нет похожих постов</div>;

  return (
    <PostsList>
      {recommendedPosts.map(post => (
        <Post
          onClick={handlePostClick}
          key={post.id}
          postImg={post.img}
          postTitle={post.title}
          postCreatedAt={post.created_at}
          postTags={post.tags}
          postId={post.id}
        />
      ))}
    </PostsList>
  );
};
